module.exports = __webpack_public_path__ + "static/img/zj-sh1.651e03cc.png";